import { FilterByPrice, FilterByWarranty } from "types/filters";

export const isFilterByPrice = (obj: any): obj is FilterByPrice => {
  return "MinPrice" in obj && "MaxPrice" in obj;
};

export const isFilterByWarranty = (obj: any): obj is FilterByWarranty => {
  return "MinMiles" in obj && "MaxMiles" in obj;
};
